module.exports = __webpack_public_path__ + "static/media/14.vintageSilver.16d3dbf5.webp";